// extracted by mini-css-extract-plugin
export var articleCard = "articleCard-module--articleCard--6HSTJ";
export var date = "articleCard-module--date--nh++H";
export var title = "articleCard-module--title--GID4o";